export default [
  {
    path: '/user/list',
    name: 'user-list',
    component: () => import('@/views/user/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'User List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'User' }, { title: 'User List', active: true }],
      permissions: ['user_list']
    }
  },

  {
    path: '/user/:id/subscription-list',
    name: 'user-subscription-list',
    component: () => import('@/views/user/subscription.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Show User Subscription',
      requiresFeature: 'enableSubscriptions',
      parent: 'userList',
      permissions: ['user_subscription_list']
      // breadcrumb: [
      //   { title: 'Dashboard', url: '/dashboard' },
      //   { title: 'Subscription', url: '/subscription/list' },
      //   { title: 'Show Subscription', active: true }
      // ],
    }
  }
]
